import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';

import notification from 'bringg-web/services/notification';
import UserTypeStore from 'bringg-web/stores/user-type/user-type-store';
import UserTypesTable from '../user-types-table/user-types-table';
import UserTypesHeader from '../user-types-header/user-types-header';
import { UserTypeModalProvider } from '../user-type-modal-context';

interface Props {
	userTypeStore: UserTypeStore;
}

class UserTypesContainer extends Component<Props> {
	async componentDidMount(): Promise<void> {
		try {
			await this.props.userTypeStore.fetchAll();
		} catch (e) {
			notification.error((e as TypeError).message, (e as any).details);
		}
	}

	render() {
		const { userTypeStore } = this.props;
		const userTypes = this.props.userTypeStore.all;

		return (
			<UserTypeModalProvider userTypeStore={userTypeStore}>
				<div className="user-types-container">
					<UserTypesHeader />
					<UserTypesTable userTypes={userTypes} />
				</div>
			</UserTypeModalProvider>
		);
	}
}

export default inject('userTypeStore')(observer(UserTypesContainer));
